import useConfig from './useConfig';

const Config = ({ children }) => {
  const config = useConfig();
  return children(config);
};

export default Config;
